import dayjs, { Dayjs } from "dayjs";

export const applyHhMmToDay = (baseDay: Dayjs, hhMm: string): Dayjs | null => {
  const timePart = dayjs(hhMm, "HH:mm", true);
  if (!timePart.isValid()) return null;
  return baseDay
    .hour(timePart.hour())
    .minute(timePart.minute())
    .second(0)
    .millisecond(0);
};

export const toDecimalHours = (timeObject: Dayjs) => {
  const hours = timeObject.hour();
  const minutes = timeObject.minute();
  return hours + (minutes / 60);
}

export const generateTimeOptions = (): string[] => {
  const times: string[] = [];
  for (let i = 0; i < 24; i++) {
    const hour = i.toString().padStart(2, "0");
    times.push(`${hour}:00`);
    times.push(`${hour}:30`);
  }
  return times;
};

export const getInUTC = (time: Dayjs) => dayjs(time).utc().format("DD-MMMM-YYYY HH:mm:ss");
export const getInUTCTime = (time: Dayjs) => dayjs(time).utc().format("HH:mm:ss");
export const minutesOfDayFromDateTime = (value: Dayjs | string): number => {
  const d = typeof value === "string" ? dayjs(value) : value;
  return d.hour() * 60 + d.minute();
};

const clockLabelToMinutes = (hhMm: string): number => {
  const parsed = dayjs(hhMm, "HH:mm", true);
  if (!parsed.isValid()) return NaN;
  return parsed.hour() * 60 + parsed.minute();
};

export const getEndTimeOptionsAfterStart = (
  startTime: Dayjs | string | null | undefined,
  allOptions: string[] = generateTimeOptions()
): string[] => {
  if (startTime == null) {
    return allOptions;
  }
  const startMinutes = minutesOfDayFromDateTime(startTime);
  return allOptions.filter(
    (option) => clockLabelToMinutes(option) > startMinutes
  );
};

export const isSameDayTimeRangeInverted = (
  startTime: Dayjs | string | null | undefined,
  endTime: Dayjs | string | null | undefined
): boolean =>
  Boolean(
    startTime &&
    endTime &&
    minutesOfDayFromDateTime(endTime) <= minutesOfDayFromDateTime(startTime)
  );